import { Helmet } from 'react-helmet';

export default function Home() {
    return (
        <>
            <Helmet>
                <title>A. Page Code</title>
                <meta name="description" content="Basic example" />
            </Helmet>
            <h1>We have been doing stuff for quite a while...</h1>
        </>
    );
}